import { DashboardViewSkeleton } from "./components/DashboardView/DashboardViewSkeleton";

export const GoogleDashboardPageSkeleton = () => {
  return <DashboardViewSkeleton />;
};
